<template>
  <Div class="test_paper">
    <MyTransition :myName="'up'">
      <Popup v-if="popupStatus">
        <PopupCheck v-if="popup == 'check'" :text="successText" @go="popupAction" @cancel="poupupEnter"></PopupCheck>
        <PopupSuccess v-if="popup == 'success'" :text="successText" @check="poupupEnter"></PopupSuccess>
        <PopupError v-if="popup == 'error'" :text="successText" @check="poupupEnter"></PopupError>
      </Popup>
    </MyTransition>

    <template v-if="this.score === 100">
      <div class="test_descript_print">
        <h1>
          恭喜您得到滿分
          <span>100</span>分
        </h1>
        您需要列印您的考卷並簽名上傳至系統，完成考試審核。
        <div class="test_paper_btn">
          <button class="btn_primary" @click="print">列印</button>
        </div>
        <div class="mark">如未當下列印，也請先存檔該pdf。關閉視窗後無法再重新打開</div>
      </div>
    </template>
    <template v-else>
      <div class="test_top flex">
        <div class="course_name">{{ this.courseName }}</div>
        <div class="basic">
          <div>姓名：{{ this.userName }}</div>
        </div>
      </div>
      <div class="test_paper_inner contain_white">
        <Loading part></Loading>
        <div class="test" v-for="(item, index) in test" :key="index">
          <div class="test_title flex">
            <div class="index">{{ index + 1 }}</div>
            {{ item.question }}
          </div>
          <div class="test_option">
            <el-radio-group v-model="answer[index]">
              <el-radio :label="q.answer_item" v-for="(q, i) in item.answer_list" :key="i">
                <span class="answer_index">{{ q.answer_item }}</span>
                : {{ q.answer_text }}
              </el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="test_paper_btn">
        <button class="btn_primary" @click="enter">送出</button>
      </div>
    </template>
  </Div>
</template>
<style lang="scss">
.test_paper {
  text-align: left;
  margin: 30px auto;

  .test_top {
    justify-content: space-between;
    align-items: flex-end;
    margin: 10px 20px;

    .course_name {
      font-size: 40px;
      font-weight: bold;
    }
  }

  .test_paper_inner {
    padding: 1px 30px;

    // border: 1px solid #ccc;
    // border-radius: 5px;
    .test {
      margin: 50px 0;

      .test_title {
        margin: 10px 0;
        font-size: 20px;

        .index {
          margin: 0 10px 0 0;
          font-weight: bold;
          color: var(--mainColor);
        }
      }

      .test_option {
        .answer_index {
          font-weight: bold;
        }
      }
    }
  }

  .test_paper_btn {
    width: 200px;
    margin: 20px auto;
  }

  .test_descript_print {
    text-align: center;

    h1 {
      margin: 10px 0;
      font-size: 20px;
      font-weight: bold;
    }
  }
}

.el-radio__label {
  font-size: 18px;
}
</style>
<script>
export default {
  name: "test",
  data() {
    return {
      test: [],
      answer: [],
      popupStatus: false,
      successText: null,
      popup: null,
      statues: null,
      score: null
    };
  },
  computed: {
    userID() {
      return this.$route.query.userID;
    },
    userName() {
      return this.$route.query.userName;
    },
    courseName() {
      return this.$route.query.courseName;
    },
    courseID() {
      return this.$route.query.courseID;
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.answer = [];
      this.$http.api.vendor.cousreTest(this.courseID).then(res => {
        this.test = res.data;
      });
    },
    enter() {
      this.popupStatus = true;
      this.successText = "確定送出嗎";
      this.popup = "check";
    },
    popupAction() {
      this.poupupEnter();
      //判斷他是否重考
      if (this.statues == "reTest") {
        //重考
        //先把重考的狀態歸null
        this.statues = null;
        //重新撈取考題
        this.getData();
      } else {
        //不是重考
        //計算一題的分數
        const total = 100 / this.test.length;
        //宣告儲存對的題目的數量
        let right = null;
        let question = [];
        this.test.forEach((el, index) => {
          //計算他有對的提目數量
          if (this.answer[index] == el.correct_answer) {
            right++;
          }
          question.push(el.question_id);
        });
        //計算總分
        this.score = Math.round(total * right);

        //抓出這次考試的題目

        if (this.score == 100) {
          this.$http.api.vendor
            .score(this.userID, this.courseID, {
              score: this.score,
              question: question
            })
            .then(res => {
              console.log(res);
            })
            .catch(error => {
              this.popupStatus = true;
              this.popup = "error";
              this.successText = `系統錯誤`;
            });
        } else {
          this.$http.api.vendor
            .score(this.userID, this.courseID, {
              score: this.score,
              question: question
            })
            .then(res => {
              this.popupStatus = true;
              this.popup = "error";
              this.statues = "reTest";
              this.successText = `您的考試得分為:${this.score}，考試成績沒通過，請重新考過`;
            })
            .catch(error => {
              console.log(error);
              this.popupStatus = true;
              this.popup = "error";
              this.successText = `系統錯誤`;
            });
        }
      }
    },
    poupupEnter() {
      // const action =new Promise((resolve,reject)=>{
      //    this.popupStatus = false;
      //     resolve()
      // })
      // return action

      this.popupStatus = false;
      if (this.popup == "error" && this.statues == "reTest") {
        this.popupStatus = true;
        this.successText = "立刻重新考試？";
        this.popup = "check";
      }
    },
    print() {
      const link = this.$router.resolve({
        name: "score",
        query: {
          userID: this.userID,
          courseID: this.courseID,
          courseName: this.courseName,
          userName: this.userName
        }
      });
      window.open(link.href, "_blank");
    }
  },
  mounted() { }
};
</script>